import React,{useState,useEffect} from 'react';
import FormControl from '@mui/material/FormControl';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Select,{SelectChangeEvent} from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import BottomButtons from './BottomButtons';
import useMediaQuery from '@mui/material/useMediaQuery';
import {Theme} from './Theme';
import {Dataset} from './Inc';
import useStyles from './Styles';

interface MailsHourProps {
	isOpen:boolean,
	value:number,
    update(value:number):void,
    close(): void,
}

const MailsHour: React.FC<MailsHourProps> = (props)=> {
    const classes = useStyles();
	const fullScreen = useMediaQuery(Theme.breakpoints.down('sm'));
	const [states,setStates] = useState({
		hour: 0,
	});
	const changeHour = (event: SelectChangeEvent) => {
		const hour = parseInt(event.target.value);
		setStates({...states,hour:hour});
    };	
	const update = ()=>{
		props.update(states.hour);
	}

	useEffect(()=>{
		if( props.isOpen ){
			setStates({...states,hour:props.value});
		}
	},[props.isOpen]);

	if(!props.isOpen){
		return (null);
	}

	const hours:Dataset[] = [];
	for( let i=0; i<24; i++ ){
		hours.push({
			id: String(i),
			label: String(i)+'時',
		});
	}

	return (
		<Dialog
			fullScreen={fullScreen}
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={true}
			onClose={(event: object, reason: string) =>{
				if( reason!=="backdropClick" ){
					props.close();
				}
			}}			
		>
			<DialogTitle color='primary'>売上レポート送信時刻の設定</DialogTitle>
			<DialogContent dividers>
				<div className={classes.confirmGuide}>
					毎日の売上レポートを受け取る時刻を設定して下さい。<br/>
					<div className={classes.hintList}>
					※大量にメールを送信する都合上、設定した時刻より数分から数十分程度遅れる場合があります。
					</div>
				</div>
				<FormControl fullWidth={true}>
                <Select
                    value={String(states.hour)}
                    onChange={changeHour}
                    inputProps={{
                        name: 'hour',
                        id: 'hour',
                    }}
                    margin="none"
					variant="standard"
                    style={{marginTop:"0.3em"}}
                >
                    {hours.map((option:Dataset,index:number) => {
						const key = "option"+index;
						return (
							<MenuItem key={key} value={option.id}>
								{option.label}
							</MenuItem>
						)
					})}
                </Select>					
				</FormControl>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<BottomButtons button1='設定する' onClick1={update} button2='やめる' onClick2={props.close} top={0} bottom={0}/>
			</DialogActions>
        </Dialog>
	);
}

export default MailsHour;
